import {SideNavigation} from "@dreebit-registry/vsm-microservice-components";
import {Box, } from "@mui/joy";
import React from "react";
import {useTranslation} from "react-i18next";
import Breadcrumbs, {breadcrumbConfig} from "../../components/Breadcrumbs";
import {Navigate, Route, Routes, useLocation} from "react-router-dom";
import ProfileInformation from "../../components/ProfileInformation";
import NotificationsSettings from "../../components/NotificationsSettings";
import NotificationSubscriptionsList from "../../components/NotificationSubscriptionsList";
import IotReportSubscriptionsList from "../../components/IotReportSubscriptionsList";
import About from "./about";
import LegacyRouteRedirect from "../../components/LegacyRouteRedirect";
import useBreadcrumbs from "use-react-router-breadcrumbs";


const ProfileDetail = () => {
    const {t} = useTranslation()
    const breadcrumbs = useBreadcrumbs(breadcrumbConfig(t));
    const location = useLocation();


    const navItems = [
        { label: t('Information'), to: `/profile/information` },
        {
            label: t('Notification Settings'),
            subItems: [
                { label: t('Preferences'), to: `/profile/notificationSettings/preferences` },
                { label: t('Installed Base'), to: `/profile/notificationSettings/installedBase` },
                { label: t('IoT Reports'), to: `/profile/notificationSettings/iotReports` },
            ],
        },
        { label: t('About'), to: `/profile/about` },
    ];

    // SideNavigation initializes its expanded-group state once at mount based
    // on the current pathname. Re-key it per top-level section so navigating
    // into a submenu from outside auto-expands the matching parent group.
    const sectionKey = location.pathname.split("/").slice(0, 3).join("/");

    return (
        <div className={"flex-row full-height full-width"}>
            <Box sx={{
                width: 320,
                borderRight: "1px solid #ccc",
                margin: "12px 0",
                padding: "0 12px"
            }}>
                <SideNavigation key={sectionKey} navItems={navItems}/>
            </Box>
            <Box className={"full-width"} sx={{flex: 1, padding: "12px", display: "flex", flexDirection: "column", minHeight: 0, overflow: "hidden"}}>
                <Breadcrumbs breadcrumbs={breadcrumbs}/>
                <Box sx={{flex: 1, minHeight: 0, display: "flex", flexDirection: "column"}}>
                    <Routes>
                        <Route path="information" element={<ProfileInformation />}/>
                        <Route path="notificationSettings/preferences" element={<NotificationsSettings />}/>
                        <Route path="notificationSettings/installedBase" element={<NotificationSubscriptionsList />}/>
                        <Route path="notificationSettings/iotReports" element={<IotReportSubscriptionsList />}/>
                        <Route path="about" element={<About />}/>
                        <Route path="notification-settings/subscriptions" element={<Navigate to={`/profile/notificationSettings/installedBase`} replace/>}/>
                        <Route path="notification-settings/*" element={<LegacyRouteRedirect />}/>
                        <Route path="notifications" element={<Navigate to={`/profile/notificationSettings/preferences`} replace/>}/>
                        <Route path="*" element={<Navigate to={`/profile/information`} replace/>}/>
                    </Routes>
                </Box>
            </Box>
        </div>
    );
}
export default ProfileDetail;
